module.exports = __webpack_public_path__ + "static/media/2.7acdf3a5.jpg";